import Vue from "vue";
import bugsnag from "@bugsnag/js";
import bugsnagVue from "@bugsnag/plugin-vue";

const bugsnagClient = bugsnag({
  apiKey: "12a330e57d7cd0228c5a57922f56767a",
  appVersion: process.env.VUE_APP_VERSION
});
bugsnagClient.use(bugsnagVue, Vue);

export default bugsnagClient;
